import axios from 'axios';
import { getNonGwApiRoot } from '../../../constants/ParamountReactConstants';

export function fetchItemPrices(itemId: number) {
  return {
    type: 'FETCH_ITEM_PRICES',
    payload: axios.get(`${getNonGwApiRoot()}/items/${itemId}/prices`),
  };
}
